import { useOutletContext } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { BookOpen } from 'lucide-react';
import { portalApi } from '../../../api/portal.js';
import { TimelineEntry } from '../../../components/portal/TimelineEntry.jsx';

/**
 * The pet's life diary: consultations, photo memories and milestones merged by
 * date, newest first. Internal staff notes are never included.
 */
export function Timeline() {
  const { selectedPet } = useOutletContext();
  const petId = selectedPet && selectedPet._id;

  const query = useQuery({
    queryKey: ['portal', 'timeline', petId],
    queryFn: () => portalApi.getTimeline(petId),
    enabled: Boolean(petId)
  });

  if (!petId) return null;

  const entries = (query.data && query.data.entries) || [];

  return (
    <div className="pt-2">
      <h2 className="mb-5 text-2xl font-semibold text-portal-ink">Il diario di {selectedPet.name}</h2>

      {query.isLoading && (
        <div className="space-y-4">
          {[0, 1, 2].map((i) => <div key={i} className="shimmer h-20 rounded-portal" />)}
        </div>
      )}

      {query.isError && (
        <p className="text-portal-ink-muted">Non riusciamo a caricare il diario in questo momento.</p>
      )}

      {query.isSuccess && entries.length === 0 && (
        <div className="rounded-portal bg-portal-card p-10 text-center shadow-portal">
          <BookOpen className="mx-auto h-9 w-9 text-portal-ink-faint" strokeWidth={1.5} />
          <p className="mt-3 text-portal-ink-muted">
            La storia di {selectedPet.name} inizia qui. Le visite e i ricordi compariranno in questa pagina.
          </p>
        </div>
      )}

      {query.isSuccess && entries.length > 0 && (
        <ul>
          {entries.map((entry, i) => (
            <TimelineEntry key={i} entry={entry} last={i === entries.length - 1} />
          ))}
        </ul>
      )}
    </div>
  );
}
